import { render, staticRenderFns } from "./MyBlowMoldingMachineDetails.vue?vue&type=template&id=283295d6&"
import script from "./MyBlowMoldingMachineDetails.vue?vue&type=script&lang=js&"
export * from "./MyBlowMoldingMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyBlowMoldingMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports